import React from "react";
import { Navigate } from 'react-router-dom';

interface PrivateRouteProps {
    children: React.ReactNode;
    roleRequired: string[];  
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({children, roleRequired}) => {
    const userRole = localStorage.getItem('role');
    const userId = localStorage.getItem('userId');

    if (!userId) {
        return <Navigate to="/" />;
    }

    if (!roleRequired.includes(userRole || '')) {
        return <Navigate to="/dashboard" />;
    }

    return <> {children} </>
};

export default PrivateRoute;